export default "__VITE_ASSET__CYRNxRn___"